
    import common from "@/util/common";
    import {defineComponent, reactive, computed, ComputedRef} from "vue";
    import {useStore} from "@/store";
    import { Tab, Tabs } from 'scvant';
    const {VUE_APP_PLUSDEAL_PROMISEFRAME} = process.env
    interface State {
        activeName: string;
        contentTextRender: object[];
        plusProtocolUrl: string;
    }
    export default defineComponent({
        name: "explainFreeCheck",
        components: {
            [Tabs.name]: Tabs,
            [Tab.name]: Tab,
        },
        setup() {
            let state: State = reactive({
                contentTextRender: [],
                activeName: '90天赔付保障范围',
                plusProtocolUrl: VUE_APP_PLUSDEAL_PROMISEFRAME
            })
            window.scrollTo(0,0);
            let store = useStore()
            let reportData: ComputedRef<{}> = computed<{}>(() => store.state.reportData)
            const {componentList} = reportData.value as any
            // for (let i=0; i<componentList.length; i++) {
            //     let item = componentList[i];
            //     if (item.code === 'serviceDesc') {
            //         let plusProtocolUrl = common.getDataByCode(item.configItems, 'PlusProtocolUrl', 'value', '');
            //         if (plusProtocolUrl) {
            //             state.plusProtocolUrl = plusProtocolUrl
            //         }
            //         break;
            //     }
            // }
            state.contentTextRender = [
                {
                    title: '90天收购保障及重要部件赔付保障范围',
                    label: '保障范围',
                    content: [
                        '被检车辆在检测报告出具前是D级事故车、火烧车或泡水车而我们出具的检测报告未显示，即“三非”检测失误;被检车辆的发动机主体、变速箱主体在检测报告出具前出现拆卸未换、漏油、渗油、修复痕迹而我们出具的检测报告未显示，即发动机、变速箱检测失误。',
                    ]
                },
                {
                    title: '保障时间',
                    content: [
                        '“三非”检测失误的保障期间是承保受益人交易过户完成之日(含当日)起90日。发动机、变速箱检测失误的保障期间是承保激活次日起365日(含当日)且新增公里数不超过 10000公里。 获取保障的前提需要激活，检测报告出具日起(含当日)90日内您在我们的系统内录入承保受益人信息进行激活，过期失效。',
                        '请在车辆完成交易及过户后，微信搜索【268V车况检测专家】小程序，进入保障激活页面，填写成交信息及上传交易凭证，激活90天收购保障后，我们将向您发送《268V检测保障承诺书》。'
                    ]
                },
                {
                    title: '承保流程',
                },
                {
                    title: '承保受益人',
                    content: [
                        '<b>检测报告出具日起(含当日)90日内，被检车辆的当前所有人(以转移登记为准)，且需同时符合以下所有条件:1)检测报告出具后被检车辆转移次数为1次或2次，2)当前所有人已支付合理对价，完成了车辆过户，3)在报告激活期限内完成了承保激活。您应当向我们提交承保受益人信息并接受我们的核验。</b>'
                    ]
                },
                {
                    title: '承保责任',
                    content: [
                        '1、“三非”检测失误: ',
                        'prop_up_height12',
                        '(1)、被检车辆在检测报告出具前是D级事故车、火烧车或泡水车而我们出具的检测报告未显示该情况的，经我们复检确认后，按照下列标准承担责任:<b>我们或我们的指定方按照交易价格购买该车辆，或者就承保受益人购车的交易价格和处置价格的差价进行差额补偿。</b>',
                        'prop_up_height12',
                        '事故车包含C级事故车和D级事故车，符合承保范围内的D级事故车错检，我们才会按交易价格回购或按购车交易价格和处置价格的差价进行差额补偿。C级事故车的错检，我们不承担回购和差价补偿的责任。',
                        'prop_up_height12',
                        '交易价格指:被检车辆在检测报告出具后90天内，承保受益人购买被检车辆的成交价格; ',
                        'prop_up_height12',
                        '处置价格指:被检车辆被判定为D级事故车、火烧车、泡水车判定错误后以拍卖方式处置的价格。',
                        'prop_up_height12',
                        '<b>(2)、交易价格合理性评估:我们有权对交易价格合理性进行评估，如交易价格超出市场合理价</b>（市场合理价系我们根据“268V”估价系统、各拍卖交易平台、其他平台内的相同/类似车况的车辆价格综合得出）<b>5%的，我们仅能以市场合理价为上限进行赔付，超出部分不赔付。</b>',
                        'prop_up_height12',
                        '<b>(3)、自检测报告出具后，车辆出现新增明显损伤的，车辆赔付金额应扣除损伤维修费和新增损伤带来的二次销售车价折损。</b>',
                        'prop_up_height12',
                        '<b>2、发动机、变速箱检测失误: </b>',
                        'prop_up_height12',
                        '(1)、被检车辆在检测报告出具前变速箱主体出现拆卸未换、漏油、渗油、修复痕迹，检测报告未体现的，且承保激活时您在我们系统里录入的汽车公里数照片显示的公里数与检测报告里显示的公里数差额不超过200公里，<b>在承保期限内我们负责维修。</b> ',
                        'prop_up_height12',
                        '(2)、被检车辆在检测报告出具前发动机主体(不含皮卡、油改气车辆、转子发动机车辆、纯电、混合动力车辆、燃料电池车)出现拆卸未换、漏油、渗油、修复痕迹、油改气，检测报告未体现的，且承保激活时您在我们系统里录入的汽车公里数照片显示的公里数与检测报告里显示的公里数差额不超过200公里，<b>在承保期限内我们负责维修。</b>',
                        'prop_up_height12',
                        '(3)、变速箱和发动机主体两者累计总赔付金额不超过10000元。',
                        'prop_up_height12',
                        '(4)、发动机、变速箱承保标准特别说明:被检车辆同时符合不存在D级事故车、火烧车和泡水车任一情形、变速箱、发动机不存在承保标准中列明的问题的，才被判定为符合承保标准;如果被检车辆不存在D级事故车、火烧车或泡水车任一情形，但变速箱或发动机任一部件不符合承保标准的，我们仅对车辆的D级事故车、火烧车或泡水车情形进行承保;<b>如果被检车辆存在D级事故车、火烧车或泡水车任一情形的，不论变速箱或发动机是否符合承保标准，我们均不予承保，您应当审慎进行交易及其他任何决策; </b>',
                        'prop_up_height12',
                        '<b>3、如果被检车辆满足D级事故车、火烧车、泡水车判定失误的，即使同时满足其他赔付条件，我们也仅按照D级事故车、火烧车、泡水车判定失误的赔付标准进行赔付。</b>',
                        'prop_up_height12',
                        '<b>4、加购项检测失误: </b>',
                        'prop_up_height12',
                        '在检测报告有效期内，符合条件的委托人或承保受益人发现加购项目存在承保缺陷，而检测报告未予以准确反映的，经我们复检后确认检测失误的,268V向委托方或者承保受益人进行一次性赔偿，具体赔偿标准详见<i class="goJGDesc">《加购服务协议》</i>。',
                    ]
                },
                {
                    title: '承保受益人如何索赔',
                    content: [
                        '1、争议发起时需提供的资料：',
                        '能够证明268V检测存在失误的照片、视频或其他保险公司证明材料或其他268V认为必要且合理的文件；',
                        'prop_up_height12',
                        '2、索赔时效：承保受益人发起索赔后，经我们复检确认检测报告结论错误，承保受益人需在收到通知之日起（含当日）7个自然日内提交所有资料，否则视为放弃索赔。',
                        'prop_up_height12',
                        '3、承保受益人向我们提出保障范围内的赔付请求时，有义务提供如下材料：',
                        '（1）承保受益人的身份证或企业营业执照；',
                        '（2）书面索赔申请原件；',
                        '（3）被检车辆交易合同、支付车款的转账电子回单、车辆行驶证、机动车登记证、车辆过户发票；',
                        '（4）我们的检测报告、我们出具的268V检测保障承诺书（线上）；',
                        '（5）如您提出发动机、变速箱检测失误的，除上述文件外，需额外提供车辆表显公里数照片；',
                        '（6）其他我们认为必要且合理的文件。'
                    ]
                },
                {
                    title: '双方权利义务',
                    content: [
                        '<b>1.检测师开始检测后，如因您的原因中途放弃检测或检测完成后不认可检测报告的，不可退款。</b>',
                        'prop_up_height20',
                        '2.我们至迟在检测完成后48小时内出具检测报告，您应当在收到检测报告后再进行交易或其他决策。您未认真阅读检测报告而导致的损失，我们不承担相关责任。',
                        'prop_up_height20',
                        '3.注意事项：',
                        'prop_up_height20',
                        '（1）我们并非检测车辆部件的功能状态、改装情况或其他。',
                        'prop_up_height20',
                        '<b>（2）受限不可检：检测过程中如遇车辆结构、检测环境以及其他因素导致检测项目无法检测，或局部部件需拆解或举升才能检测，但车主或委托人未同意或未授权造成无法检测，我们将会在检测报告中或补充说明中明确提示该部位“受限不可检”。<u>因受限不可检造成车辆结论有误的，我们不承担任何责任。若车主或委托人不配合检测导致我们检测师无法完成车辆检测的，则检测终止，且我们有权不退检测费用。</u>前述“车主或委托人未同意或未授权”包括：A. 车主或委托人以口头或书面形式明确告知我们检测师不同意或不授权; 或者B. 我们检测师以书面形式（包括微信等）获取车主或委托人同意或授权，车主或委托人【2】分钟内未予以答复的，视为“车主或委托人未同意或未授权”。</b>',
                        'prop_up_height20',
                        '（3）您或承保受益人发起索赔后，我们有权自行或委派第三方对被检车辆进行复查、勘验，您及承保受益人有义务予以配合。',
                        'prop_up_height20',
                        '（4）您或承保受益人对我们的复检结论、收购价格等存在异议的，可自行委托其他具备二手车评估鉴定资质的第三方机构按照GB∕T 30323-2013《二手车鉴定评估技术规范》国家标准和T/CADA 18-2021《乘用车鉴定评估技术规范》CADA团体标准规定的程序出具鉴定评估报告，并及时提交给我们。经我们或者生效法律文书确认我们的复检结论有误的，我们将承担鉴定评估费用，但最多不超过1500元；经我们或者生效法律文书确认我们的复检结论无误的，该鉴定评估费用由您或承保受益人自行负担。',
                    ]
                },
                {
                    title: '免责',
                    weight: 'bold',
                    content: [
                        '具备下列情形之一的，268V免责：',
                        'prop_up_height12',
                        '1.检测报告出具后超过90天有效期或车辆已完成交易过户的，您(委托方)无权再发起索赔；',
                        'prop_up_height12',
                        '2.检测报告激活是承保受益人获得索赔的必要流程，请在检测报告有效期内完成激活；为提升用户体验，我们并未要求在激活时提供所有的索赔所需材料，因此激活成功不代表受益人一定是符合条件的承保受益人。我们有权在受益人发起索赔后要求其提交全部的索赔材料并接受我们的核验。对于不符合承保受益人标准的，即使激活成功也无法获得三非错检回购或差价赔付权益；',
                        'prop_up_height12',
                        '3.我们的检测服务是为了提升交易效率，保障消费者的合法权益，并不免除车辆卖方的法定责任，如我们发现您或者承保受益人在明知车辆存在事故、火烧、泡水情况或其他严重缺陷情况下交易的，我们不承担任何保障和赔付责任；',
                        'prop_up_height12',
                        '4.检测报告出具后，车辆在报告激活期限内未转移登记或在报告激活期限内未激活的，报告及对应承诺失效；',
                        'prop_up_height12',
                        '5.检测报告出具后，不论是否激活，车辆转移登记次数超过2次的，报告及对应承诺失效；',
                        'prop_up_height12',
                        '6.承保激活后车辆再次转移登记的，承保失效，激活受益人及再次购买人均无权索赔；',
                        'prop_up_height12',
                        '7.您或承保受益人提出异议的时间超过对应的承保期限；',
                        'prop_up_height12',
                        '8.您或承保受益人未在我们通知提交索赔材料的7个自然日内提供合法、有效的各类必要证明材料及索赔材料的；',
                        'prop_up_height12',
                        '9.受限不可检：已经在检测报告中予以提示的，则相关部件的真实情况或因此造成车辆结论有误的情况不在我们车辆检测保障承诺范围内；',
                        'prop_up_height12',
                        '10.检测报告仅可接受一次索赔，我们赔付完后，报告及对应承诺失效，您或受益人均无权索赔；',
                        'prop_up_height12',
                        '11.因结构件改装（含改装打孔、改装切割、改装焊接、改装变形、改装更换）导致的损伤不在D级事故车判定标准范畴，因此引发的争议不属于检测失误；',
                        'prop_up_height12',
                        '12.如因您或车辆本身问题，如车辆部件贴透明材料或改色车衣、改装车辆隔音、加装车辆底盘装甲、改装车辆地板以及其他变更车辆实际的情况，车辆部件异常缺陷的，无法确认部件状况，上述情况导致我们根据当前检测标准和技术客观无法准确检测的，或因您改装部件影响相关评级的，不视为我们检测错误，我们无需向您承担本协议项下的赔付责任；',
                        'prop_up_height12',
                        '13.ECU检测所展示的车辆运行数据均为静态数据，所以检测报告中ECU的诊断结果信息仅供参考；由此产生的任何事故和故障不在我们的车辆检测承保范围内；',
                        'prop_up_height12',
                        '14.您或承保受益人因各类原因未能配合我们或我们委派的第三方或保险公司对车辆进行复查和勘查的；',
                        'prop_up_height12',
                        '15.检测当日车辆的真实状况不足以反映车辆曾发生过事故、火烧、泡水问题的；',
                        'prop_up_height12',
                        '16.我们出具车辆检测报告后因任何原因导致车况状态发生变化，并因此导致检测结果不再适用的；',
                        'prop_up_height12',
                        '17.《268V检测认定标准》会不定期更新，如有更新，我们会通过系统通知您。新标准上线后我们会使用新标准进行检测和输出报告。您知晓并同意我们使用新标准检测并输出报告，且因新旧标准不同导致的检测报告不一致的我们免责；',
                        'prop_up_height12',
                        '18.因不可归责于我们的原因造成被检车辆损失扩大的，我们就扩大部分损失免责；',
                        'prop_up_height12',
                        '19.“表显里程”是检测人员依据所检测车辆里程表显示的数据填写的，该信息仅供参考，表显里程数不在我们的车辆检测承保范围内；',
                        'prop_up_height12',
                        '20.被检车辆存在违反《中华人民共和国道路交通安全法》第十六条所规定情形的，我们免责，并可以将违法线索移送公安机关依法处理。上述情形包括：拼装机动车或者擅自改变机动车已登记的结构、构造或者特征；改变机动车型号、发动机号、车架号或者车辆识别代号；伪造、变造或者使用伪造、变造的机动车登记证书、号牌、行驶证、检验合格标志、保险标志；使用其他机动车的登记证书、号牌、行驶证、检验合格标志、保险标志。',
                    ],
                },
            ];
            return {
                state
            }
        },
        methods: {
            goJGDesc(e){
                console.dir(e.target);
                if (e.target.className === 'goJGDesc') {
                    this.$router.push({
                        path: '/pdfView',
                        query: {
                            pdfurl: this.state.plusProtocolUrl
                        }
                    })
                }
            },
            goBack(){
                history.go(-1)
            },
        }
    })
